import { isNil } from 'lodash';

export const alphanumericComparator = (
  value1: string | number,
  value2: string | number,
): number => {
  if (isNil(value1) && isNil(value2)) {
    return 0;
  }
  if (isNil(value1)) {
    return -1;
  }
  if (isNil(value2)) {
    return 1;
  }

  /**
   * Use standard numeric comparison for numeric values because
   * String.localeCompare() improperly sorts values with decimals
   *
   * @example:
   *     "0.75".localeCompare("0.5555", undefined, { numeric: true })
   *     Returns -1 instead of 1;
   */
  const value1Number: number = Number(value1);
  const value2Number: number = Number(value2);

  const shouldUseNumericComparison =
    !isNaN(value1Number) && !isNaN(value2Number);

  if (shouldUseNumericComparison) {
    return value1Number - value2Number;
  }

  return String(value1).localeCompare(value2 as string, undefined, {
    sensitivity: 'base',
  });
};
